const TopicOne = () => {
  return (
    <div className="quality-section-market">
      <div className="quality-header-market">
        <h1>Precision in Every Tick</h1>
        <p>
          Turn past market data into future trading success
          {/* Whether you’re hedging against inflation or capitalizing on short-term
          price shifts, The Pips provides an intuitive platform for both
          precision and performance. */}
        </p>
      </div>
    </div>
  );
};

export default TopicOne;
